import type { VeloClient } from '@wix/velo-client';
import { getRepoType, createPackageManager } from '@wix/package-manager';
import { getProjectDependencies } from '../velo.js';
import { saveWixLock } from '../files/wix.lock.js';

export async function createDependenciesService(
  projectFolder: string,
  veloClient: VeloClient
) {
  const repoType = await getRepoType(projectFolder);
  const packageManager = await createPackageManager(repoType);

  const updateWixLock = async () => {
    const dependencies = await getProjectDependencies(projectFolder);
    const wixLockContent = await veloClient.generateWixLockFile(dependencies);

    await saveWixLock(projectFolder, wixLockContent);
  };

  return {
    install: async (packageName?: string) => {
      if (packageName) {
        await packageManager.runInstallPackage(projectFolder, packageName);
      } else {
        await packageManager.runInstall(projectFolder);
      }

      await updateWixLock();
    },
    uninstall: async (packageName: string) => {
      await packageManager.runUninstallPackage(projectFolder, packageName);
      await updateWixLock();
    },
  };
}
